import React from 'react';
import { Link } from 'react-router';
import Card from 'components/Card';
import { ResourceCardElement } from 'components/ResourceCardElements';
import styles from 'styles/resourceCard';
import WorkroomType from 'types/workroom';
import { urls } from 'helpers/url';
import cx from 'classnames';

const WorkroomCard = ({ workroom }) =>
  <Link className={styles.viewLink} to={urls.workroom(workroom)}>
    <Card
      key={workroom.id}
      className={cx({ [styles.inactive]: !workroom.active, [styles.resourceCard]: true })}
      inactive={!workroom.active}
    >
      <ResourceCardElement title="Workroom Name" size="small" value={workroom.name} />
      <ResourceCardElement title="Address" size="small" value={workroom.address} />
      <ResourceCardElement title="City" size="small" value={workroom.city} />
      <ResourceCardElement title="State" size="small" value={workroom.state} />
      <ResourceCardElement title="Zip" size="small" value={workroom.zip_code} />
      <ResourceCardElement title="Phone Number" size="small" value={workroom.phone_number} />
    </Card>
  </Link>;

WorkroomCard.propTypes = {
  workroom: WorkroomType.isRequired,
};

export default WorkroomCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/workrooms/components/workroomCard.jsx